/**
 * Copyright (c) 2017-present, Hungry Marketplace, Inc.
 * All rights reserved.
 *
 * HungryCoreJS is a node-based client for consuming our Hungry API services.
 * It also serves as a general template to help kickstart our React Redux apps.
 */

import coordinators from './coordinators'
import * as models from './models'
import { createStore, getStore } from './store'
import { BaseService, initServices, loadServices } from './services'
import axios from './api/axios'
import config from './config'

export default Object.freeze({
  createStore, getStore,
  models,
  BaseService, initServices, loadServices,
  coordinators,
  config,
  axios,
})
